import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ChevronRight } from "lucide-react";

export function MoveDeliveryDialog({
  open,
  onOpenChange,
  movingDelivery,
  loadingRounds,
  otherRounds,
  movingTo,
  onMove,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#18181b] border-white/10 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white">Sposta consegna</DialogTitle>
        </DialogHeader>
        {movingDelivery && (
          <div className="space-y-3">
            <div className="p-3 rounded-lg bg-white/5 border border-white/10">
              <p className="text-white font-medium text-sm">{movingDelivery.client_name}</p>
              <p className="text-xs text-zinc-500">
                {movingDelivery.order_numero} - {movingDelivery.total?.toLocaleString("it-IT", { style: "currency", currency: "EUR" })}
              </p>
            </div>

            <p className="text-xs text-zinc-500 px-1">Seleziona il giro di destinazione:</p>

            {loadingRounds ? (
              <div className="flex justify-center py-4">
                <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-orange-500" />
              </div>
            ) : otherRounds.length === 0 ? (
              <p className="text-center text-zinc-500 py-4 text-sm">Nessun altro giro disponibile</p>
            ) : (
              <div className="max-h-60 overflow-y-auto space-y-2">
                {otherRounds.map((r) => (
                  <button
                    key={r.id}
                    data-testid={`move-to-round-${r.id}`}
                    onClick={() => onMove(r.id)}
                    disabled={movingTo !== null}
                    className="w-full flex items-center gap-3 p-3 rounded-lg border border-white/10 hover:border-orange-500/30 hover:bg-white/5 transition-colors text-left disabled:opacity-50"
                  >
                    <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
                      <span className="text-orange-400 font-mono font-bold text-lg">{r.letter}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white font-medium text-sm">
                        Giro {r.letter} del {r.date
                          ? new Date(r.date + "T00:00:00").toLocaleDateString("it-IT")
                          : new Date(r.created_at).toLocaleDateString("it-IT")}
                      </p>
                      <p className="text-zinc-500 text-xs">{r.deliveries?.length || 0} consegne</p>
                    </div>
                    {movingTo === r.id ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-orange-500 shrink-0" />
                    ) : (
                      <ChevronRight className="w-4 h-4 text-zinc-600 shrink-0" />
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
